import { lazy } from "react"

export const FinanceDataFromMailboxByIdPage = lazy(() => import("./FinanceDataFromMailboxByIdPage"))